module.exports = __webpack_public_path__ + "img/hr-cargo-wagon-shadow-1.7824c17c.png";